var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-contanier" },
    [
      _c("div", { staticClass: "opt" }, [
        _c(
          "div",
          { staticClass: "btn", on: { click: _vm.add } },
          [
            _c("svg-icon", {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "add",
                  expression: "'add'",
                },
              ],
              attrs: { className: "icon", iconClass: "add" },
            }),
            _vm._v("新增 "),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: _vm.tableData,
                  pageIndex: _vm.pagerConfig.pageIndex,
                  pageSize: _vm.pagerConfig.pageSize,
                  loading: _vm.loading,
                  isEmptyBorder: true,
                },
                on: {
                  handlePageChange: _vm.handlePageChange,
                  sortChange: _vm.sortChange,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "isActived",
                      fn: function (row) {
                        return [
                          _c("div", {
                            staticClass: "circle",
                            style: {
                              "background-color": row.scope.isActived
                                ? " #35BA83"
                                : "#FE453D",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                row.scope.isActived ? "使用中" : "未使用"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "userRole",
                      fn: function (row) {
                        return _vm._l(
                          row.scope.userRole,
                          function (item, $index) {
                            return _c(
                              "div",
                              { key: $index },
                              [_c("el-tag", [_vm._v(_vm._s(item.key))])],
                              1
                            )
                          }
                        )
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permissson",
                                            rawName: "v-permissson",
                                            value: "enable_disable",
                                            expression: "'enable_disable'",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        on: {
                                          click: () => {
                                            _vm.changeStatus(
                                              !row.scope.isActived,
                                              row.scope
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            !row.scope.isActived
                                              ? "启用"
                                              : "停用"
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permissson",
                                            rawName: "v-permissson",
                                            value: "distribute",
                                            expression: "'distribute'",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.userRole(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("权限分配")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("img", {
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  730640455
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("UserRoleDialog", {
        attrs: {
          dialogFormVisible: _vm.dialogFormVisible,
          userRoleId: _vm.editData.id,
        },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
      _c("add-user-role", {
        attrs: { dialogVisible: _vm.dialogVisible },
        on: { ok: _vm.ok2, cancel: _vm.cancel2 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }